import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { useSelector } from "react-redux";
import { SERVER_URL } from "../utils/axios";

const BackupNotificationBar = () => {
  const { getIdTokenClaims, getAccessTokenSilently } = useAuth0();
  const backupTrialInfo = useSelector(
    (state) => state.commonReducer.backupTrialInfo
  );

  if (backupTrialInfo?.trialMessage === "" && backupTrialInfo?.xeroId === "") {
    return null;
  }

  const MAX_TRIAL = 3;
  const progressPercentage =
    ((MAX_TRIAL - Number(backupTrialInfo?.trialBackupRemaining)) / MAX_TRIAL) *
    100;

  const onClickUpgrade = async () => {
    try {
      await getAccessTokenSilently();
      const token = await getIdTokenClaims();
      window.location.href =
        SERVER_URL +
        "/connect/xero?id=" +
        backupTrialInfo.xeroId +
        "&token=" +
        token.__raw;
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {backupTrialInfo?.trialMessage && (
        <div className="w-full bg-black text-white py-2 z-50 top-0 left-0 right-0">
          <div className="flex items-center justify-center space-x-3">
            {/* Backup count text */}
            <span className="text-sm font-normal">
              {backupTrialInfo.trialMessage}
            </span>
  
            {/* Progress bar */}
            <div className="w-48 h-2 bg-gray-700 rounded-full overflow-hidden">
              <div
                className="h-full bg-blue-400 rounded-full"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
  
            {/* Upgrade button */}
            <button
              onClick={onClickUpgrade}
              className="bg-black text-white text-sm px-4 py-1 rounded-md border border-gray-600 hover:bg-gray-800 transition-colors"
            >
              Subscribe
            </button>
          </div>
        </div>
      )}
    </>
  );
  
};

export default BackupNotificationBar;
